export default __webpack_public_path__ + "static/media/FIRE SAFETY SIMULATOR.649d24da.JPG";